import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  HiQueueList,
  HiBuildingLibrary,
  HiBanknotes,
  HiPaperAirplane,
  HiInboxArrowDown,
  HiCalendarDays,
  HiTrash,
  HiArrowUturnLeft,
} from "react-icons/hi2";

import classes from "./Transaction.module.css";
import { deleteTransaction } from "../../api/api";
import { reverseTransaction } from "../../api/api";
import { alertActions } from "../../store/alert-slice";
import Spinner from "../UI/Spinner";
import { getAuthToken } from "../../util/authToken";

const Transaction = (props) => {
  const [showSpinner, setShowSpinner] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const buttonMsg = props.reversed ? "Reversed" : "Reverse";
  const date = new Date(props.date).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });

  const reverseHandler = async () => {
    setShowSpinner(true);

    const res = await reverseTransaction(getAuthToken(), props.id);

    if (res.status === "success") {
      dispatch(
        alertActions.setState({ message: res.message, status: res.status })
      );
      navigate("/transactions");
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }

    setShowSpinner(false);
  };

  const deleteHandler = async () => {
    setShowSpinner(true);
    const res = await deleteTransaction(getAuthToken(), props.id);
    if (!res) {
      dispatch(
        alertActions.setState({
          message: "Transaction deleted successfully",
          status: "success",
        })
      );
      navigate("/transactions");
    } else {
      dispatch(
        alertActions.setState({ message: res.message, status: "error" })
      );
    }
    setShowSpinner(false);
  };

  return (
    <motion.article
      className={classes.card}
      layout
      whileHover={{ y: -3 }}
      transition={{ type: "spring", stiffness: 400, damping: 28 }}
    >
      {showSpinner && <Spinner />}
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiQueueList className={classes.rowIcon} aria-hidden />
          Type
        </span>
        <span>{props.type}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiBuildingLibrary className={classes.rowIcon} aria-hidden />
          Destination
        </span>
        <span>{props.destination}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiBanknotes className={classes.rowIcon} aria-hidden />
          Amount
        </span>
        <span>{props.amount}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiPaperAirplane className={classes.rowIcon} aria-hidden />
          Sender
        </span>
        <span>{props.sender}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiInboxArrowDown className={classes.rowIcon} aria-hidden />
          Receipient
        </span>
        <span>{props.receipient}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.rowLabel}>
          <HiCalendarDays className={classes.rowIcon} aria-hidden />
          Date
        </span>
        <span>{date}</span>
      </div>
      <div className={classes.actions}>
        <button
          type="button"
          className={classes.btnDelete}
          onClick={deleteHandler}
        >
          <HiTrash className={classes.btnIcon} aria-hidden />
          Delete
        </button>
        <button
          type="button"
          className={classes.btnReverse}
          onClick={reverseHandler}
          disabled={props.reversed}
        >
          <HiArrowUturnLeft className={classes.btnIcon} aria-hidden />
          {buttonMsg}
        </button>
      </div>
    </motion.article>
  );
};

export default Transaction;
